export const Resend = Symbol("Resend");
export type Resend = typeof Resend;
